import React from 'react';
import { IconProps } from './types';

const AnomalyTrackerIcon: React.FC<IconProps> = props => {
  const { fillColor = 'var(--bg-primary)', width = 24, height = 24 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.7891 16.7979L19.9996 21.0084"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M0.664062 6.79826C2.03578 3.4052 5.36726 1.00879 9.25036 1.00879C14.3661 1.00879 18.503 5.16668 18.503 10.2614C18.503 15.3562 14.3767 19.5035 9.25036 19.5035C5.63013 19.5035 2.48676 17.4162 0.968143 14.381"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M0 10.3661H3.48421C4.15789 10.3661 4.77895 9.9661 5.10526 9.33452L6.05263 7.54505C6.4 6.88189 7.30526 7.01873 7.47368 7.7661L8.82105 13.6398C8.98947 14.3872 9.92632 14.524 10.2526 13.8293L11.8105 10.5766"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.3807 10.7135C13.0965 10.7135 13.6754 10.1345 13.6754 9.41876C13.6754 8.70297 13.0965 8.12402 12.3807 8.12402C11.6649 8.12402 11.0859 8.70297 11.0859 9.41876C11.0859 10.1345 11.6649 10.7135 12.3807 10.7135Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default AnomalyTrackerIcon;
